export default __webpack_public_path__ + "static/media/arrow.4528628e.svg";